// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Validation Banner Styles */
.validation-banner .validation-banner-content {
  display: flex;
  align-items: start;
}
.validation-banner .validation-banner-content .validation-banner-icon {
  margin-right: 8px;
  margin-top: 2px;
  margin-bottom: 2px;
  flex-shrink: 0;
}
.validation-banner .validation-banner-content .validation-banner-text {
  flex: 1;
}
.validation-banner .validation-banner-content .validation-banner-text strong {
  display: inline;
  margin-bottom: 0;
}
.validation-banner .validation-banner-content .validation-banner-text .invalid-fields-list {
  margin-top: 8px;
}
.validation-banner .validation-banner-content .validation-banner-text .invalid-fields-list .invalid-fields-columns {
  margin: 0;
  padding-left: 16px;
  columns: 2;
  column-gap: 24px;
  list-style-type: disc;
}
.validation-banner .validation-banner-content .validation-banner-text .invalid-fields-list .invalid-fields-columns li {
  margin-bottom: 4px;
  break-inside: avoid;
  page-break-inside: avoid;
  -webkit-column-break-inside: avoid;
  word-break: break-word;
}

/* Media Query for screens below 1700px */
@media (max-width: 1699px) {
  .validation-banner .validation-banner-content {
    flex-direction: column;
    align-items: flex-start;
  }
  .validation-banner .validation-banner-content .validation-banner-icon {
    margin-bottom: 8px;
    margin-right: 0;
  }
  .validation-banner .validation-banner-content .validation-banner-text {
    width: 100%;
  }
  .validation-banner .validation-banner-content .validation-banner-text .invalid-fields-list .invalid-fields-columns {
    columns: 1;
  }
  .validation-banner .validation-banner-content .validation-banner-text .invalid-fields-list .invalid-fields-columns li {
    margin-bottom: 6px;
  }
}
/* Media Query for very small screens */
@media (max-width: 768px) {
  .validation-banner .validation-banner-text .invalid-fields-list .invalid-fields-columns {
    columns: 1;
    padding-left: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/claims-app/claims-app-submission/claims-app-submission.component.scss"],"names":[],"mappings":"AAAA,6BAAA;AAEE;EACE,aAAA;EACA,kBAAA;AAAJ;AAEI;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;AAAN;AAGI;EACE,OAAA;AADN;AAGM;EACE,eAAA;EACA,gBAAA;AADR;AAIM;EACE,eAAA;AAFR;AAIQ;EACE,SAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,qBAAA;AAFV;AAIU;EACE,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,kCAAA;EACA,sBAAA;AAFZ;;AAUA,yCAAA;AACA;EAEI;IACE,sBAAA;IACA,uBAAA;EARJ;EAUI;IACE,kBAAA;IACA,eAAA;EARN;EAWI;IACE,WAAA;EATN;EAYQ;IACE,UAAA;EAVV;EAYU;IACE,kBAAA;EAVZ;AACF;AAkBA,uCAAA;AACA;EAIQ;IACE,UAAA;IACA,kBAAA;EAnBR;AACF","sourcesContent":["/* Validation Banner Styles */\r\n.validation-banner {\r\n  .validation-banner-content {\r\n    display: flex;\r\n    align-items: start;\r\n    \r\n    .validation-banner-icon {\r\n      margin-right: 8px;\r\n      margin-top: 2px;\r\n      margin-bottom: 2px;\r\n      flex-shrink: 0;\r\n    }\r\n    \r\n    .validation-banner-text {\r\n      flex: 1;\r\n      \r\n      strong {\r\n        display: inline;\r\n        margin-bottom: 0;\r\n      }\r\n      \r\n      .invalid-fields-list {\r\n        margin-top: 8px;\r\n        \r\n        .invalid-fields-columns {\r\n          margin: 0;\r\n          padding-left: 16px;\r\n          columns: 2;\r\n          column-gap: 24px;\r\n          list-style-type: disc;\r\n          \r\n          li {\r\n            margin-bottom: 4px;\r\n            break-inside: avoid;\r\n            page-break-inside: avoid;\r\n            -webkit-column-break-inside: avoid;\r\n            word-break: break-word;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n/* Media Query for screens below 1700px */\r\n@media (max-width: 1699px) {\r\n  .validation-banner {\r\n    .validation-banner-content {\r\n      flex-direction: column;\r\n      align-items: flex-start;\r\n      \r\n      .validation-banner-icon {\r\n        margin-bottom: 8px;\r\n        margin-right: 0;\r\n      }\r\n      \r\n      .validation-banner-text {\r\n        width: 100%;\r\n        \r\n        .invalid-fields-list {\r\n          .invalid-fields-columns {\r\n            columns: 1;\r\n            \r\n            li {\r\n              margin-bottom: 6px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n/* Media Query for very small screens */\r\n@media (max-width: 768px) {\r\n  .validation-banner {\r\n    .validation-banner-text {\r\n      .invalid-fields-list {\r\n        .invalid-fields-columns {\r\n          columns: 1;\r\n          padding-left: 12px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
